import { getComponentSelectorId } from '../../shared/logic/get-component-selector-id';
import SubActivityView from '../../sub-activity/sub-activity-view';
import {
  InteractiveSequenceAttempt,
  ViewProps,
} from './settings/interactive-response.constants';
import InteractiveResponsePlay from './play/interactive-response-sequence';
import type { InteractiveResponseAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { ClassroomAnswerInstruction } from 'approot/activity-builder/classroom/classroom-answer.style';
import { useInteractiveImages } from '../shared/interactive-response-shared.hooks';
import InteractiveResponseImageZoom from '../shared/interactive-response-image-zoom';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import { InteractiveAudioProvider } from '../shared/interactive-audio.context';

const InteractiveSequenceLargeView = ({
  isPlaying,
  finishGame,
  setCloseModalCallback,
  showAnswer,
  ...props
}: ViewProps & {
  isPlaying: boolean;
  onAnswerAttempt: InteractiveSequenceAttempt;
  finishGame: () => void;
  attemptAnswers?: InteractiveResponseAnswerFragment;
  setCloseModalCallback: (callback: Function | undefined) => void;
  showAnswer: boolean;
}) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const {
    currentItem,
    isNextDisabled,
    isPrevDisabled,
    onNextImage,
    onPrevImage,
    onImageClick,
    reset: resetImages,
  } = useInteractiveImages();

  return (
    <InteractiveAudioProvider>
      <ActivitySheetInnerContent id="content">
        <ActivitySheetInnerMax>
          <ClassroomAnswerInstruction
            id={getComponentSelectorId(props.id)}
            style={{
              display: isVisible ? 'none' : '',
            }}
          >
            <SubActivityView
              withTTSButton
              componentId={props.id}
              componentType={props.type}
              subActivityDetails={props.subActivityProperties}
            >
              <InteractiveResponsePlay
                showAnswer={showAnswer}
                {...props}
                onExpandImage={(id, dragItems) => {
                  setCloseModalCallback(() => closeModal());
                  onImageClick(id, dragItems);
                  openModal();
                }}
              />
            </SubActivityView>
          </ClassroomAnswerInstruction>
        </ActivitySheetInnerMax>
      </ActivitySheetInnerContent>

      {isVisible && currentItem ? (
        <InteractiveResponseImageZoom
          itemToPreview={currentItem}
          isNextDisabled={isNextDisabled}
          isPrevDisabled={isPrevDisabled}
          variant={props.properties.interactiveResponse.variant}
          onNext={onNextImage}
          onPrevious={onPrevImage}
          onBackClick={() => {
            setCloseModalCallback(undefined);
            resetImages();
            closeModal();
          }}
        />
      ) : null}
    </InteractiveAudioProvider>
  );
};

export default InteractiveSequenceLargeView;
